import { SPTopExtendQuestionCollapse } from 'components/top-sp/extend/questions/collapse'
import { CopySvg } from 'components/top/extend/svg/copy'
import { LeftSlashSvg } from 'components/top/extend/svg/left-slash'
import { RightSlashSvg } from 'components/top/extend/svg/right-slash'
import { ELEMENT_ID } from 'utils/constant'
import { getGTM } from 'utils/functions'

export function SPPointPart06() {
  return (
    <div
      id={ELEMENT_ID.FAQ}
      className='px-[16px] pb-[40px] background-point-sp-part-06 bg-repeat'
    >
      <div className='max-w-[360px] w-full mx-auto flex flex-col items-center'>
        <div className='flex items-center gap-[8px] mt-[40px]'>
          <LeftSlashSvg className='w-[7px] h-[11px]' />
          <h2 className='font-semibold text-[20px] leading-[36px] tracking-[2px]'>
            ポイントのよくある質問
          </h2>
          <RightSlashSvg className='w-[7px] h-[11px]' />
        </div>

        <div className='flex items-center gap-[8px] mt-[16px] self-start'>
          <span aria-hidden className='w-4 h-4 rounded-full bg-accent-green' />
          <h3 className='text-[16px] font-semibold leading-[1.8] tracking-[1.6px]'>
            サントリーウエルネスポイント
          </h3>
        </div>

        <div className='mt-[12px]'>
          <SPTopExtendQuestionCollapse
            title='ジハンピ対象の自販機でポイントを利用するにはどうすればいいですか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'ウエルネスポイント_1',
            })}
            duration={0.5}
          >
            <div className='p-4 rounded-b-lg bg-bg-blue'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='w-8 object-contain'
              />
              <div>
                <div className='rounded-[4px] p-[16px] bg-white mt-[10px]'>
                  <p className='font-semibold text-[14px] tracking-widest leading-[1.8]'>
                    ご利用の前に、まずはComadoアプリマイページで「利用可能ポイント」をご確認ください。
                  </p>
                  <img
                    src='/images/top-extend/questions/1/pic-01.webp'
                    alt='ご利用の前に、まずはComadoアプリマイページで「利用可能ポイント」をご確認ください。'
                    className='w-full object-contain mt-[14px]'
                  />
                  <p className='mt-[14px] text-[11px] leading-[2] tracking-wider'>
                    ※利用可能ポイントが購入金額よりも少ない場合はご利用できません。
                  </p>
                </div>

                <div className='rounded-[4px] p-[16px] bg-white mt-[10px]'>
                  <div className='flex before:content-["1"] before:shrink-0 before:mr-[8px] before:w-[24px] before:h-[24px] before:rounded-full before:border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold text-[14px] tracking-widest leading-[1.8]'>
                      Comadoアプリのマイページから「自販機で利用する（ジハンピ）」画面を表示する
                    </span>
                  </div>
                  <img
                    src='/images/top-extend/questions/1/pic-02.webp'
                    alt='Comadoアプリのマイページから「自販機で利用する（ジハンピ）」画面を表示する'
                    className='w-full object-contain mt-[14px]'
                  />
                </div>

                <div className='rounded-[4px] p-[16px] bg-white mt-[10px]'>
                  <div className='flex before:content-["2"] before:shrink-0 before:mr-[8px] before:w-[24px] before:h-[24px] before:rounded-full before:border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold text-[14px] tracking-widest leading-[1.8]'>
                      自販機の商品ボタンを押す
                    </span>
                  </div>
                  <img
                    src='/images/top-extend/questions/1/pic-03.webp'
                    alt='自販機の商品ボタンを押す'
                    className='w-full object-contain mt-[14px]'
                  />
                </div>

                <div className='rounded-[4px] p-[16px] bg-white mt-[10px]'>
                  <div className='flex before:content-["3"] before:shrink-0 before:mr-[8px] before:w-[24px] before:h-[24px] before:rounded-full before:border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold text-[14px] tracking-widest leading-[1.8]'>
                      Comadoアプリで「タッチを開始する」を押す
                    </span>
                  </div>
                  <img
                    src='/images/top-extend/questions/1/pic-04.webp'
                    alt='Comadoアプリで「タッチを開始する」を押す'
                    className='w-full object-contain mt-[14px]'
                  />
                </div>

                <div className='rounded-[4px] p-[16px] bg-white mt-[10px]'>
                  <div className='flex before:content-["4"] before:shrink-0 before:mr-[8px] before:w-[24px] before:h-[24px] before:rounded-full before:border-[2px] before:border-illust-tealblue before:flex before:items-center before:justify-center before:text-[14px] before:leading-none before:font-semibold'>
                    <span className='font-semibold text-[14px] tracking-widest leading-[1.8]'>
                      以下が表示されたら、ジハンピ対応端末にスマートフォンの背面（カメラ側）でタッチする
                    </span>
                  </div>
                  <img
                    src='/images/top-extend/questions/1/pic-05.webp'
                    alt='以下が表示されたら、ジハンピ対応端末にスマートフォンの背面（カメラ側）でタッチする'
                    className='w-full object-contain mt-[14px]'
                  />
                </div>
              </div>
            </div>
          </SPTopExtendQuestionCollapse>
        </div>

        <div className='mt-[12px]'>
          <SPTopExtendQuestionCollapse
            title='サントリーウエルネスポイントは何をすれば貯まりますか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'ウエルネスポイント_2',
            })}
          >
            <div className='p-4 rounded-b-lg bg-bg-blue flex items-start gap-2'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='w-8 object-contain'
              />
              <p className='text-[16px] font-medium leading-[2] tracking-[0.48px]'>
                ・サントリーウエルネス商品（定期的なお届けも含む）や
                <br />
                サントリーグループ商品のご購入によってポイントが貯まります。
                <br />
                ・オトク継続便のお客様で、Comadoアプリをご利用いただき、
                <br />
                飲用習慣タスクや健康習慣タスクを実行いただくことでポイントがたまります。
              </p>
            </div>
          </SPTopExtendQuestionCollapse>
        </div>

        <div className='mt-[12px]'>
          <SPTopExtendQuestionCollapse
            title='貯まったポイントは何ポイントから使えますか?'
            duration={0.2}
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'ウエルネスポイント_3',
            })}
          >
            <div className='p-4 rounded-b-lg bg-bg-blue flex items-start gap-2'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='w-8 object-contain'
              />
              <p className='text-[16px] font-medium leading-[2] tracking-[0.48px]'>
                1ポイントから利用することができます。
              </p>
            </div>
          </SPTopExtendQuestionCollapse>
        </div>

        <div className='flex items-center gap-[8px] mt-[32px] self-start'>
          <span aria-hidden className='w-4 h-4 rounded-full bg-accent-green' />
          <h3 className='text-[16px] font-semibold leading-[1.8] tracking-[1.6px]'>
            チャレンジ
          </h3>
        </div>

        <div className='mt-[12px]'>
          <SPTopExtendQuestionCollapse
            title='チャレンジに達成期限はありますか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'チャレンジ_1',
            })}
          >
            <div className='p-4 rounded-b-lg bg-bg-blue flex items-start gap-2'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='w-8 object-contain'
              />
              <p className='text-[16px] font-medium leading-[2] tracking-[0.48px]'>
                チャレンジには全部で4つのカテゴリがあり、カテゴリにより達成期限は異なります。
                <br />
                ・はじめてのチャレンジ：オトク継続便ご契約状態でログインいただいてから7日間です。
                <br />
                ・今日のチャレンジ：毎日0:00に達成記録がリセットされるため、達成期限は毎日23:59です。
                <br />
                ・週間のチャレンジ：毎週月曜日0:00に達成記録がリセットされるため、達成期限は毎週日曜日23:59です。
                <br />
                ・限定チャレンジ：各限定チャレンジに記載されている期日の23:59です。
              </p>
            </div>
          </SPTopExtendQuestionCollapse>
        </div>

        <div className='mt-[12px]'>
          <SPTopExtendQuestionCollapse
            title='4,000歩数以上歩いたのにポイントが貯まりません。'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'チャレンジ_2',
            })}
          >
            <div className='p-4 rounded-b-lg bg-bg-blue flex items-start gap-2'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='w-8 object-contain'
              />
              <div className='flex flex-col'>
                <p className='text-[16px] font-medium leading-[2] tracking-[0.48px]'>
                  歩数でポイントを貯めるためには、4,000歩歩いた当日中にComadoアプリを開き、「トップページ」もしくは「歩数記録ページ」を訪れる必要があります。
                </p>

                <div className='flex items-center gap-[8px] mt-[16px]'>
                  <div className='w-[24px] h-[24px] rounded-full border-2 border-illust-tealblue flex items-center justify-center'>
                    <span className='text-[14px] leading-[16px] text-black font-semibold'>
                      1
                    </span>
                  </div>
                  <p className='text-[16px] leading-[2] tracking-[0.48px] font-semibold'>
                    ComadoのTOPページに訪れる
                  </p>
                </div>
                <img
                  src='/images/point/part-06/pic-01.webp'
                  alt='pic-01'
                  className='w-full object-contain'
                />
                <div className='flex items-center gap-[8px] mt-[16px]'>
                  <div className='w-[24px] h-[24px] rounded-full border-2 border-illust-tealblue flex items-center justify-center'>
                    <span className='text-[14px] leading-[2] tracking-[0.48px] text-black font-semibold'>
                      2
                    </span>
                  </div>
                  <p className='text-[16px] leading-[2] tracking-[0.48px] font-semibold'>
                    歩数記録ページに訪れる
                  </p>
                </div>
                <img
                  src='/images/point/part-06/pic-02.webp'
                  alt='pic-02'
                  className='w-full object-contain'
                />

                <p className='text-[16px] leading-[2] tracking-[0.48px] mt-[8px] font-medium'>
                  アプリを開いても歩数が「0歩」と表示されている場合、
                  <br />
                  恐れ入りますが以下のよくある質問をご確認ください。
                  <br />
                  ・iPhoneをご利用の方
                  <br />
                  よくある質問＞歩数＞常に0歩と表示されてしまう（iPhone）
                  <br />
                  ・Androidをご利用の方
                  <br />
                  よくある質問＞歩数＞常に0歩と表示されてしまう（Android）
                </p>
              </div>
            </div>
          </SPTopExtendQuestionCollapse>
        </div>

        <div className='mt-[12px]'>
          <SPTopExtendQuestionCollapse
            title='ポイントはどのタイミングでもらえますか？'
            {...getGTM({
              event_name: 'accordion_click',
              content_type: 'point_FAQ',
              content_id: 'チャレンジ_3',
            })}
          >
            <div className='p-4 rounded-b-lg bg-bg-blue flex items-start gap-2'>
              <img
                src='/images/top-extend/questions/a.webp'
                alt='answer'
                className='w-8 object-contain'
              />
              <p className='text-[16px] font-medium leading-[2] tracking-[0.48px]'>
                ポイントの種類によってタイミングが異なります。
                <br />
                以下のタイミングで、今回、獲得頂いたポイントが、これまでためていたポイントに加算されます。
                <br />
                <br />
                ■サントリーウエルネス商品購入によって獲得するポイント
                <br />
                ご注文頂いた商品を出荷した翌日にポイントが反映されます。
                <br />
                ECサイトの注文完了時点、または、お電話による注文完了時点ではありません。目安として、注文完了時点から数日後の反映となります。
                <br />
                <br />
                ■Comadoアプリの対象チャレンジ実行によって獲得するポイント
                <br />
                ポイント進呈対象となる「チャレンジ」を実行した翌週の月曜日に、ポイントが進呈されます。
                <br />
                <br />
                但し、キャンペーンなどによるポイント進呈のタイミングは上記の限りではありません。
              </p>
            </div>
          </SPTopExtendQuestionCollapse>
        </div>

        <div className='flex items-end gap-[3px] mt-[19px] justify-center'>
          <a
            target='_blank'
            href='https://secure.okbiz.jp/swe/category/show/37?key=400000147'
            className='text-[16px] leading-[32px] tracking-[0.48px] font-medium underline text-center'
          >
            よくある質問をもっと見る
          </a>
          <CopySvg className='mb-[5px]' />
        </div>
      </div>
    </div>
  )
}
